import {
    Card, CardContent, CardHeader, Grid,
    IconButton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import React from "react";
import { SmartLink} from "../abelcommon";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {InputItem,OutputsItem} from './TransactionItem'


interface MempoolTxItemProps {
    txid: string;
    inputs: any;
    outputs: any;
}

function MempoolTxItem({txid, inputs, outputs}: MempoolTxItemProps) {
    return (
        <Card sx={{
            margin: 1,
            padding: 1,
            display: 'flex',
            boxShadow: 3,
            borderRadius: 2,
            width: 1,
            overflow: 'auto',
        }}>
            <Grid container direction="row" spacing={1}>
                <Grid item xs={8}>
                    <Card>
                        <CardHeader
                            title={<Typography variant={'h5'} textAlign={'center'}>{`Inputs`}</Typography>}
                            sx={{p:0}}
                        />
                        <CardContent sx={{maxHeight: 250, overflow: 'auto'}}>
                            {inputs.map((input: any, i: any) => (
                                <InputItem key={`${txid}_input_${i}`} ringid={input.ringid}
                                           outpoints={input.outpoints}
                                           serialnumber={input.serialnumber}
                                />
                            ))}
                        </CardContent>
                    </Card>
                </Grid>
                {/*<Grid item xs={2}>*/}
                {/*    <Typography variant="body2">*/}
                {/*        <KeyboardArrowRightIcon fontSize={"large"}/>*/}
                {/*    </Typography>*/}
                {/*</Grid>*/}
                <Grid item xs={4}>
                    <Card>
                        <CardHeader
                            title={<Typography variant={'h5'} textAlign={'center'}>{`Outputs`}</Typography>}
                            sx={{p:0}}
                        />
                        <CardContent sx={{maxHeight: 220, overflow: 'auto'}}>
                            <OutputsItem
                                key={`${txid}_outpoints`}
                                outputs={outputs}
                            />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Card>
    );
}


function MempoolTxRow({data, i,allowExpand}: { data: any, i: number,allowExpand:boolean }) {
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <TableRow key={data.txid} onClick={() => setOpen(!open)} sx={{height:60}}>
                <TableCell>
                    <SmartLink to={`/mempool/0x${data.txid}`}>
                        0x{data.txid.slice(0, 8) + '..' + data.txid.slice(-8)}
                    </SmartLink>
                </TableCell>
                {/*<TableCell>*/}
                {/*    <SmartLink to={`/block/${data.blockheight}`}>{data.blockheight}</SmartLink>*/}
                {/*</TableCell>*/}
                {/*<TableCell>{formatDurationAbbr(dts, ts)} ago</TableCell>*/}
                {/*<TableCell align={'right'}>{data.txtype}</TableCell>*/}
                <TableCell align={'right'}>{data.vin.length}</TableCell>
                <TableCell align={'right'}>{data.vout.length}</TableCell>
                {/*<TableCell align={'right'}>{formatRFC7231(dts).substring(5)}</TableCell>*/}
                <TableCell align={'right'}>{data.fee} ABEL</TableCell>
                {allowExpand && <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        sx={{bgcolor: 'transparent'}}
                        // onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>}
            </TableRow>
            {allowExpand &&<TableRow key={`expand_tx_${data.txid}`}>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={8}>
                    <Stack direction='column' spacing={1}>
                        {open && <MempoolTxItem key={`block_${data}_tx_${data.txid}`}
                                         txid={data.txid} inputs={data.vin}
                                         outputs={data.vout}
                        />}
                    </Stack>
                </TableCell>
            </TableRow>}
        </>
    );
}

interface MempoolTxListProps {
    data: any[];
    allowExpand?:boolean;
}

function MempoolTxList({data,allowExpand=true}: MempoolTxListProps) {
    return (
        <TableContainer sx={{width: {xs: 'auto', sm: 1}}}>
            <Table
                sx={{
                    width: {xs: 'max-content', sm: 1},
                    tableLayout: 'auto',
                    '& .MuiTableCell-root': {px: 1, py: 1},
                }}
            >
                <TableHead sx={{'& .MuiTableCell-root': {fontWeight: 'bold'}}}>
                    <TableRow>
                        <TableCell>Hash (txid)</TableCell>
                        {/*<TableCell>Block</TableCell>*/}
                        {/*<TableCell>Age</TableCell>*/}
                        {/*<TableCell align={'right'}>Type</TableCell>*/}
                        <TableCell align={'right'}>Inputs</TableCell>
                        <TableCell align={'right'}>Outputs</TableCell>
                        {/*<TableCell align={'right'}>Time</TableCell>*/}
                        <TableCell align={'right'}>Fee</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.length===0 && <TableRow sx={{height:60}}>
                        <TableCell colSpan={8} >
                            <Typography sx={{textAlign:'center'}}>No transaction found in mempool at this moment.</Typography>
                        </TableCell>
                    </TableRow>}
                    {data.length!==0 && data.map((d, i) => <MempoolTxRow key={d.txid} data={d} i={i} allowExpand={allowExpand}/>)}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default MempoolTxList;